import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

// Api client
import ObservationsClient from "@common/api/ObservationsClient";

// Actions
import CustomerFormAction from "@common/redux/actions/CustomerFormAction";

// Hooks and Helpers
import fetchObservationsData from "@common/components/helpers/Observations/fetchObservationsData";
import prepareObservationsData from "./prepareObservationsData";
import useLogin from "@common/components/hooks/useLogin";
import { parseObservationResponse } from "../compliance";
import useCompliance from "../../hooks/useCompliance";
import useLinkedAlert from "../../hooks/useLinkedAlert";

const useObservationForm = ({ record, customerRecord, moodOptions }) => {
  const methods = useFormContext();

  useEffect(() => {
    fetchObservationsData();
    CustomerFormAction.dispatch({ formType: "" });
  }, []);

  const [{ siteGuid }] = useLogin();

  const { resetComplianceForms, submitComplianceForm } = useCompliance();
  const { linkedAlertData } = useLinkedAlert();

  const resetForm = (redirect) => {
    resetComplianceForms(redirect);
    fetchObservationsData();
  };

  const onSubmit = (data) => {
    if (!methods.formState.isValid) {
      console.error(methods.formState.errors);
      return;
    }

    const payload = prepareObservationsData(
      data,
      record,
      customerRecord,
      moodOptions,
      siteGuid,
      linkedAlertData,
    );

    submitComplianceForm({
      client: ObservationsClient,
      payload,
      resetForm,
      desktopCallback: (response) =>
        methods.reset(parseObservationResponse(response)),
    });
  };

  return { onSubmit, resetForm };
};

export default useObservationForm;
